<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center h-20 p-6 pb-0 gap-x-2">
            <!-- Light version -->
            <img class="dark:hidden w-12" src="assets/images/logo/Icosaedro_logo.svg" alt="Icosaedro" />
            <!-- Dark version -->
            <img class="hidden dark:flex w-12" src="assets/images/logo/Icosaedro_logo.svg" alt="Icosaedro" />
            <div class="text-4xl">{{ "app_name" | transloco }}</div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>

        <instance-selector class="flex-auto"></instance-selector>

        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <languages></languages>
            <fuse-fullscreen class="hidden md:flex"></fuse-fullscreen>
            <!--
            <search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>
            <messages></messages>
            <notifications></notifications>
            <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
            </button>
            -->
            
            <!--
            <button
                mat-icon-button
                [mat-menu-trigger-for]="supportMenu"
                matTooltip="{{ 'toolbar.support' | transloco }}"
            >
                <mat-icon>contact_support</mat-icon>
            </button>
            -->
            <notifications></notifications>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
    >
        <span class="font-medium text-secondary">Icosaedro &copy; {{ currentYear }}</span>
    </div>
</div>

<!-- Quick chat 
<quick-chat #quickChat="quickChat"></quick-chat>
-->

<!-- Support Menu -->
<mat-menu #supportMenu="matMenu" [overlapTrigger]="false">
    <button mat-menu-item [routerLink]="['/help-center']">
        <mat-icon>help_outline</mat-icon>
        {{ "toolbar.helpCenter" | transloco }}
    </button>
    <button mat-menu-item [routerLink]="['/changelog']">
        <mat-icon>sync</mat-icon>
        {{ "toolbar.about" | transloco }}
    </button>
</mat-menu>
